function updateCartCount() {
    $.getJSON('/cart.js', function(cart) {
        console.log('xxx', cart)
        $('#cart-count').text(cart.items.length);
    });
}

updateCartCount();


function createCustomSelect(containerSelector, onChangeCallback) {
    $(containerSelector).each(function() {
        const $container = $(this);
        const $select = $container.find('select');

        $select.hide()

        const $arrow = $('<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.4697 18.5303C11.7626 18.8232 12.2374 18.8232 12.5303 18.5303L17.3033 13.7574C17.5962 13.4645 17.5962 12.9896 17.3033 12.6967C17.0104 12.4038 16.5355 12.4038 16.2426 12.6967L12 16.9393L7.75736 12.6967C7.46447 12.4038 6.98959 12.4038 6.6967 12.6967C6.40381 12.9896 6.40381 13.4645 6.6967 13.7574L11.4697 18.5303ZM11.25 6L11.25 18L12.75 18L12.75 6L11.25 6Z" fill="#241E18"/></svg>');
        const $customSelect = $('<div class="custom-select"></div>');
        const $selectStyled = $('<div class="select-styled"><span></span></div>');
        const $selectOptions = $('<ul class="select-options"></ul>');

        let $firstOption = $select.find('option:first');
        let defaultValue = $firstOption.val();
        let isSelected = false

        $select.find('option').each(function() {
            const $option = $(this);
            const value = $option.val();
            const text = $option.text();
            const id = $option.attr('id'); 
            let $optionItem;
            console.log($option.attr("selected"));
            

            if ($option.attr("selected") !== undefined) {
                defaultValue = value
                $firstOption = $option
                console.log(defaultValue)
                isSelected = true
                $optionItem = $(`<li data-value="${value}" class="active" id="${id}">${text}</li>`);
            } else  {

                $optionItem = $(`<li data-value="${value}" id="${id}">${text}</li>`);
            }

            $optionItem.appendTo($selectOptions);
        });

        if (!isSelected) {
            $selectOptions.find('li:first').addClass("active")
        }

        $customSelect.append($selectStyled, $selectOptions);
        $container.append($customSelect);

        $select.val(defaultValue);
        $selectStyled.append($arrow);
        $selectStyled.find('span').text($firstOption.text());

        $selectStyled.on('click', function() {
            $selectOptions.toggle();

            if($selectStyled.hasClass('active')) {
                $customSelect.removeAttr("style")
                $selectStyled.removeClass("active")
            } else {
                $customSelect.css({zIndex: 4999})
                $selectStyled.addClass("active")
            }
        });

        $selectOptions.on('click', 'li', function() {
            const value = $(this).data('value');
            const text = $(this).text();

            $selectOptions.find('li').removeClass("active")

            $(this).addClass("active")

            $select.val(value);

            $selectStyled.find('span').text(text);

            $selectOptions.hide();

            if($selectStyled.hasClass('active')){
                $selectStyled.removeClass("active")
                $customSelect.removeAttr("style")
            } else {
                $selectStyled.addClass("active")
                $customSelect.css({zIndex: 4999})
            }

            if (typeof onChangeCallback === 'function') {
                onChangeCallback(value, $container);
            }
        });
    });
}